import React from "react";
import { H4, Body } from "@irati/ui/src/Typography";
import { Radio } from "@irati/ui/src/FormItem";
import Link from "@irati/ui/src/Link";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { options } from "../../constants/contactPreferences";
var ContactPreferences = function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? null : _b, formatMessage = _a.formatMessage;
    var link = (React.createElement(Link, { href: formatMessage({ id: "account.contact.body.link.href" }), target: "_blank" }, formatMessage({ id: "account.contact.body.link.text" })));
    return (React.createElement(Flex, { direction: "column", marginBottom: 3 },
        React.createElement(H4, { marginBottom: 1 },
            React.createElement(FormattedMessage, { id: "account.contact.secondary.header" })),
        React.createElement(Body, { marginBottom: 3 },
            React.createElement(FormattedMessage, { id: "account.contact.body.text", values: { link: link } })),
        React.createElement(Radio, { name: "marketingEmailRadio", value: value, options: options(formatMessage), onChange: onChange })));
};
export default injectIntl(ContactPreferences);
